import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormSectionCard } from 'components/_basic/FormSectionCard';

import { IProfitAndLossProjectionFormTableProps } from './types';
import { FullScreenWrapper } from '../../../components/FullScreenWrapper';
import { ProfitAndLossProjectionFormBody } from '../ProfitAndLossProjectionFormBody';
import { ProfitAndLossProjectionFormHeader } from '../ProfitAndLossProjectionFormHeader';

export const ProfitAndLossProjectionFormTable: React.FC<IProfitAndLossProjectionFormTableProps> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <FormSectionCard title={t('financialPlan.profitAndLossProjection.sectionTitle')} disabled={disabled} collapsible>
      <FullScreenWrapper title={t('financialPlan.profitAndLossProjection.sectionTitle')} disabled={disabled}>
        <ProfitAndLossProjectionFormHeader disabled={disabled} />
        <ProfitAndLossProjectionFormBody disabled={disabled} />
      </FullScreenWrapper>
    </FormSectionCard>
  );
};
